<template>
  <div class="operation">
    <DisclosedReport v-if="useDisclosedReport" :code="CODE" />
    <Highway v-else-if="asset_type === '交通设施'" :asset_name="asset_name" />
    <IndustrialPark v-else-if="asset_type === '产业园'" :_asset_name="asset_name" />
    <Logistics v-else-if="asset_type === '物流仓储'" :_asset_name="asset_name" />
    <Consumption v-else-if="asset_type === '消费'" :_asset_name="asset_name" />
    <Tenancy v-else-if="asset_type === '租赁住房'" :_asset_name="asset_name" />
    <Energy v-else-if="asset_type === '能源'" :_asset_name="asset_name" />
    <DataCenter v-else-if="asset_type === '数据中心'" :_asset_name="asset_name" />
    <MunicipalEco v-else-if="asset_type === '市政生态'" :code="CODE" />
  </div>
</template>

<script>
import Highway from './highway';
import DisclosedReport from './DisclosedReport.vue';
import { loadReportCatalog } from '@/services/reportCatalog';
import IndustrialPark from './IndustrialPark';
import Logistics from './Logistics';
import Consumption from './consumption';
import Tenancy from './tenancy';
import Energy from './energy';
import DataCenter from './dataCenter';
import MunicipalEco from './municipalEco';

export default {
  components: {
    DisclosedReport,
    Highway,
    IndustrialPark,
    Logistics,
    Consumption,
    Tenancy,
    Energy,
    DataCenter,
    MunicipalEco,
  },
  data() {
    return {
      ROOTFONTFIZE: 0,
      CODE: '',
      asset_name: [],
      asset_type: '',
      useDisclosedReport: false,
    };
  },
  created() {
    this.reload();
  },
  mounted() {
    this.fnGetWidth();
    window.addEventListener('resize', this.funResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.funResize);
  },
  methods: {
    async getAssetValues() {
      const code = this.CODE;
      let fund = (this.$store.state.CODELIST || []).find(item => item.reitCode === code);
      if (!fund) {
        try {
          fund = (await loadReportCatalog(this.$https)).find(item => item.reitCode === code);
        } catch (error) {
          // The disclosure API can still present data when the optional catalogue is unavailable.
          if (code === this.CODE) this.useDisclosedReport = true;
          return;
        }
      }
      if (code !== this.CODE) return;
      const category = fund && fund.reitsTypeL2;
      const templates = ['交通设施', '产业园', '物流仓储', '消费', '租赁住房', '能源', '数据中心', '市政生态'];
      // Disclosure exists independently of the availability of a sector template
      // or the optional JLL asset integration.
      if (!fund || (category && !templates.includes(category))) {
        this.useDisclosedReport = true;
        return;
      }

      const { data } = await this.$https.get('/api/asset_value_by_jllt_code?code=' + code);

      if (code !== this.CODE) return;
      if (data.code !== 200) return this.$message.error(data.msg);
      const result = data.data || [];
      if (!result[0]) {
        this.useDisclosedReport = true;
        return;
      }
      this.asset_type = (result[0] || {})['资产类型'];
      this.useDisclosedReport = !templates.includes(this.asset_type);
      this.asset_name = result;
      // this.asset_name = [...new Set(result.map((item) => item['资产名称']))];
    },
    fnGetTheme() {
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },
    funResize() {
      this.fnGetWidth();
    },

    fnGetWidth() {
      this.ROOTFONTFIZE = localStorage.getItem('ROOTFONTFIZE');
    },

    reload() {
      this.asset_type = '';
      this.useDisclosedReport = false;
      this.CODE = window.sessionStorage.getItem('CURRENTCODE');
      this.getAssetValues();
    },
  },

  computed: {
    cssVars() {
      return {
        '--ROOTFONTFIZE': this.ROOTFONTFIZE + 'px',
      };
    },
    currentTheme() {
      return this.$store.state.theme;
    },
  },
  watch: {
    currentTheme(newVal, oldVal) {
      this.fnGetTheme();
    },
  },
};
</script>

<style lang="less" scoped>
.operation {
}
</style>
